<section class="visualizers-header">
    <app-header [title]="'menu.DESIGNER.visualizers' | translate" />
</section>

<section class="visualizers-list">
    <app-visualizer-item
        *ngFor="let item of visualizerItems"
        [imageUrl]="item.imageUrl"
        [title]="item.title"
        [description]="item.description"
        [link]="item.link"
    />
</section>